let modalElement = null;
let listenersBound = false;

const youtubeEmbedFromUrl = (url) => {
  const match = String(url || '').match(
    /(?:(?:www\.|m\.)?youtube(?:-nocookie)?\.com\/(?:watch\?(?:[^#]*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
  );
  return match ? `https://www.youtube-nocookie.com/embed/${match[1]}?autoplay=1&rel=0` : '';
};

const vimeoEmbedFromUrl = (url) => {
  const match = String(url || '').match(/(?:player\.)?vimeo\.com\/(?:video\/)?(\d+)/);
  return match ? `https://player.vimeo.com/video/${match[1]}?autoplay=1` : '';
};

const directVideoFromUrl = (url) => {
  const raw = String(url || '');
  return /\.(mp4|webm|ogg)(\?|#|$)/i.test(raw) ? raw : '';
};

const bindModalListeners = (modal) => {
  if (!modal || modal.dataset.modalBound === '1') return;
  modal.dataset.modalBound = '1';

  modal.querySelectorAll('.js-video-modal-close').forEach((node) => {
    node.addEventListener('click', () => closeVideoModal());
  });

  // Klik poza dialogiem (backdrop / padding).
  modal.addEventListener('click', (event) => {
    const dialog = modal.querySelector('.video-modal__dialog');
    if (!dialog || dialog.contains(event.target)) return;
    closeVideoModal();
  });
};

const getOrCreateModal = () => {
  if (modalElement?.isConnected) return modalElement;

  modalElement = document.querySelector('.js-video-modal');
  if (!modalElement) {
    modalElement = document.createElement('div');
    modalElement.className = 'video-modal js-video-modal';
    modalElement.innerHTML = `
      <div class="video-modal__backdrop js-video-modal-close" aria-hidden="true"></div>
      <div class="video-modal__dialog" role="dialog" aria-modal="true" aria-label="Odtwarzacz wideo">
        <button type="button" class="video-modal__close js-video-modal-close" aria-label="Zamknij">×</button>
        <div class="video-modal__player js-video-modal-player"></div>
      </div>
    `;
    document.body.appendChild(modalElement);
  }

  bindModalListeners(modalElement);
  return modalElement;
};

export const closeVideoModal = () => {
  const modal = modalElement?.isConnected ? modalElement : document.querySelector('.js-video-modal');
  if (!modal) return;
  modalElement = modal;

  modal.classList.remove('is-open');
  document.body.classList.remove('video-modal-open');

  const player = modal.querySelector('.js-video-modal-player');
  if (player) player.innerHTML = '';
};

export const openVideoModal = ({ embedUrl, src, label = 'Wideo' }) => {
  if (!embedUrl && !src) return;

  const modal = getOrCreateModal();
  const player = modal.querySelector('.js-video-modal-player');
  if (!player) return;

  player.innerHTML = '';

  if (embedUrl) {
    const iframe = document.createElement('iframe');
    iframe.src = embedUrl;
    iframe.title = label;
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; web-share');
    player.appendChild(iframe);
  } else {
    const video = document.createElement('video');
    video.src = src;
    video.controls = true;
    video.playsInline = true;
    video.autoplay = true;
    player.appendChild(video);
    video.play().catch(() => undefined);
  }

  modal.classList.add('is-open');
  document.body.classList.add('video-modal-open');
};

const resolvePlayback = (el) => {
  const player = el.closest('.js-school-about-player');
  const embedAttr = el.dataset.videoEmbed || player?.dataset.videoEmbed || '';
  const srcAttr = el.dataset.videoSrc || player?.dataset.videoSrc || '';
  const raw = el.dataset.videoUrl || el.getAttribute('href') || srcAttr || embedAttr || '';
  const embedUrl = embedAttr || youtubeEmbedFromUrl(raw) || vimeoEmbedFromUrl(raw);
  const src = embedUrl ? '' : (srcAttr || directVideoFromUrl(raw));
  const label = el.getAttribute('aria-label')
    || player?.querySelector('[aria-label]')?.getAttribute('aria-label')
    || 'Wideo';

  return { embedUrl, src, label };
};

const VIDEO_TRIGGER_SELECTOR = [
  '.js-hski-video-play',
  '.js-school-product-play',
  '.js-review-video-play',
  '.js-school-about-play',
  '.js-school-about-poster',
  '.js-hski-video-poster',
].join(', ');

const onVideoTriggerClick = (event) => {
  const trigger = event.target.closest(VIDEO_TRIGGER_SELECTOR);
  if (!trigger) return;
  if (trigger.closest('.video-modal')) return;
  if (trigger.hasAttribute('disabled')) return;

  const source = trigger.classList.contains('js-school-about-poster')
    || trigger.classList.contains('js-hski-video-poster')
    ? (trigger.querySelector('.js-hski-video-play, .js-school-about-play, .js-school-product-play') || trigger)
    : trigger;

  const playback = resolvePlayback(source);
  if (!playback.embedUrl && !playback.src) return;

  event.preventDefault();
  openVideoModal(playback);
};

const onVideoEscape = (event) => {
  if (event.key !== 'Escape') return;
  const modal = modalElement?.isConnected ? modalElement : document.querySelector('.js-video-modal');
  if (modal?.classList.contains('is-open')) {
    closeVideoModal();
  }
};

const initSchoolAboutVideo = () => {
  getOrCreateModal();

  if (!listenersBound) {
    listenersBound = true;
    document.addEventListener('click', onVideoTriggerClick);
    document.addEventListener('keydown', onVideoEscape);
  }
};

export default initSchoolAboutVideo;
